import { render, staticRenderFns } from "./d-reviewer-directory.vue?vue&type=template&id=7bf41da7&scoped=true&"
import script from "./d-reviewer-directory.vue?vue&type=script&lang=js&"
export * from "./d-reviewer-directory.vue?vue&type=script&lang=js&"
import style0 from "./d-reviewer-directory.vue?vue&type=style&index=0&id=7bf41da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf41da7",
  null
  
)

export default component.exports